import React from 'react';
import style from './acmiFlightPlanTrack.module.scss';

export class AcmiFlightPlan extends React.Component<{base: string}> {
    render(): JSX.Element {
        return (
            <div className={style.FlightTrack}>
                <div className={style.Node}/>
                <div className={style.DottedLine}>
                    <span className={style.BaseLocation}>{this.props.base}</span>
                </div>
                <div className={style.Node}/>
            </div>
        );
    }
}
